import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { DropdownButton } from "@similarweb/ui-components";

export const StyledIconWrapper = styled.div`
    display: flex;
    margin-right: 8px;
`;
export const StyledDDText = styled.div`
    display: flex;
    ${setFontVariant("input2", colorsPalettes.carbon[500])}
`;

export const StyledDropdownButton = styled(DropdownButton)`
    display: flex;
    padding-left: 16px;
`;
